import React from "react";
import PageLoadingIndicator from "../PageLoadingIndicator/PageLoadingIndicator";

import style from "./LtiLoadingSpinner.module.scss";

const LtiLoadingSpinner = () => {
  return (
    <div className={style.loadingContainer}>
      <PageLoadingIndicator />
    </div>
  );
};

export default LtiLoadingSpinner